module.exports = __webpack_public_path__ + "img/006.f8be2ad5.png";